<div class="mod mod-modal" [class.is-open]="isVisible">
    <div class="mod-modal__dialog mod-modal__dialog--small">
        <div class="mod-modal__content">
            <div class="content">
                <div class="close" (click)="close()">
                    <span class="zas-icon icon-close-tag"></span>
                </div>

                <!-- static content -->
                <p class="leader">
                    Abgeschlossene Beratungsprotokolle herunterladen
                </p>
                <p>
                    Während des Downloads werden Sie mehrmals aufgefordert
                    Dateien auf Ihrem Computer zu speichern.
                </p>

                <!-- progress indicators -->
                <p class="saved" *ngFor="let downloadedFile of downloadedFiles">
                    {{ downloadedFile }} gespeichert
                    <span class="icon-i-cta-hook"></span>
                </p>
                <p *ngIf="isDownloading" class="saved">
                    {{ fileName && fileName + " "
                    }}<span class="icon-loop spinning"></span>
                </p>
                <p
                    *ngIf="hasUnsavedFile"
                    class="zbd-inline-button"
                    (click)="saveFile()"
                >
                    {{ fileName }} speichern
                </p>

                <br />
                <p *ngIf="isPaused" class="leader">
                    Download pausiert. Zum Fortfahren speichern.
                </p>

                <!-- buttons -->
                <button
                    *ngIf="isStopped && !isInterrupted"
                    class="zas-button-cta"
                    style="margin: 0; float: none"
                    (click)="startDownload()"
                >
                    Download starten
                </button>
                <div *ngIf="isInterrupted">
                    <br />
                    <p class="zbd-inline-button" (click)="startDownload()">
                        Download neustarten
                    </p>
                </div>
                <button
                    *ngIf="isInterrupted"
                    class="zas-button-cta"
                    style="margin: 0; float: none"
                    (click)="continueDownload()"
                >
                    Download fortsetzen
                </button>
                <button
                    *ngIf="isDownloading"
                    class="zas-button"
                    style="margin: 0; float: none"
                    (click)="requestStop()"
                    [disabled]="stopRequested"
                >
                    Download pausieren
                    <span
                        *ngIf="stopRequested"
                        class="icon-loop spinning"
                    ></span>
                </button>
            </div>
        </div>
    </div>
</div>
